export default __webpack_public_path__ + "static/media/Calendar.47e4633b.svg";